module.exports = "<h1 translate>Something went wrong</h1> <p class=type-h5 translate>The product you were looking was not found or is inactive.</p> <div ng-if=\"::vm.errormessage!=''\"> <p>Error {{::vm.errormessage}}</p> </div> <br/> <p><a href=/ class=\"btn btn-outline\" translate>Return to the homepage</a></p> <br/>";


//////////////////
// WEBPACK FOOTER
// ./features/error/product-not-found.html
// module id = 594
// module chunks = 0